var heading_default = {
  "fontElementMap": "SFjga",
  "elementSpacing": "Wh5Vq",
  "headerOne": "jTnlE Wh5Vq",
  "headerTwo": "kCxlE Wh5Vq",
  "headerThree": "pRw5c Wh5Vq",
  "headerFour": "Qmzwu Wh5Vq",
  "headerFive": "Wk3aY Wh5Vq",
  "headerSix": "df-3C Wh5Vq",
  "child": "_7kgFm"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
